module.exports = __webpack_public_path__ + "media/details/onsite@2x-c84a716e.png";